import React, {createContext, useContext, useState, useEffect} from 'react'
import axios from 'axios'

import {AppContext} from './appContext'

const SettingsContext = createContext()

function SettingsContextProvider({children}) {
  const [salesforceConfigurationId, setSalesforceConfigurationId] = useState('')
  const [pluginObjects, setPluginObjects] = useState([])
  const [associatedCaseRecordType, setAssociatedCaseRecordType] = useState('An Account')

  const {jwt, updateFormMenuOptions} = useContext(AppContext)

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const result = await axios({
          method: 'get',
          url: '/api/salesforce_configurations',
          params: {
            jwt: jwt
          }
        })
        console.log("url: '/api/salesforce_configurations'")  
        console.log(result)
        setSalesforceConfigurationId(result.data.id)
        setAssociatedCaseRecordType(result.data.associatedCaseRecordType)
      } catch (error) {
        console.log(error)
      }

      try {
        const result = await axios({
          method: 'get',
          url: '/api/plugin_objects',
          params: {
            jwt: jwt
          }
        })
        console.log("url: '/api/plugin_objects'") 
        console.log(result)
        setPluginObjects(result.data.pluginObjects)
      } catch (error) {
        console.log(error)
      }
    }
 
    fetchSettings()
  }, [])
  
  const toggleSetting = (id, type) => {
    // update pluginObject clientside
    const newPluginObjects = pluginObjects.map((pluginObject) => {
      if (pluginObject.id === id) {
        const updatedSalesforceObject = {
          ...pluginObject
        }
        updatedSalesforceObject[type] = !pluginObject[type]
        return updatedSalesforceObject
      }
      return pluginObject

    })
    setPluginObjects(newPluginObjects)
    // call api
    const updateToggle = async () => {
      try {
        const result = await axios({
          method: 'patch',
          url: `/api/plugin_objects/${id}/toggle`,
          data: {
            jwt: jwt,
            type: type
          }
        })
        console.log(`url: /api/plugin_objects/${id}/toggle`) 
        console.log(result)
      } catch (error) {
        console.log(error)
      }
    }
    updateToggle().then(() => updateFormMenuOptions())
  }

  const removePluginObject = (id) => {
    // remove pluginObject on clientside
    const newPluginObjects = pluginObjects.filter((pluginObject) => {
      return pluginObject.id !== id
    })
    setPluginObjects(newPluginObjects)
    // call api
    const destroyObject = async () => {
      try {
        const result = await axios({
          method: 'delete',
          url: `/api/plugin_objects/${id}`,
          data: {
            jwt: jwt
          }
        })
        console.log(`url: /api/plugin_objects/${id}`)  
        console.log(result)
      } catch (error) {
        console.log(error)
      }
    }
    destroyObject()
  }

  const changeAssociatedCaseRecordType = (type) => {
    // update pluginObject clientside
    setAssociatedCaseRecordType(type)
    // call api
    const updateRecordType = async () => {
      try {
        const result = await axios({
          method: 'patch',
          url: `/api/salesforce_configurations/${salesforceConfigurationId}`,
          data: {
            jwt: jwt,
            associatedCaseRecordType: type
          }
        })
        console.log("url: '/api/salesforce_configurations/update_name'") 
        console.log(result)
      } catch (error) {
        console.log(error)
      }
    }
    updateRecordType()
  }

  return (
    <SettingsContext.Provider value={{pluginObjects, associatedCaseRecordType, toggleSetting, removePluginObject, changeAssociatedCaseRecordType}}>
      {children}
    </SettingsContext.Provider>
  )
}

export {SettingsContextProvider, SettingsContext}
